import config from '@/config'
import axios from 'axios'

const instance = () => {
  return axios.create({
    baseURL: `${config.serverUrl}`,
    timeout: 30000
  })
}

const orderApi = {
  putUpdateOrderTracking: (request) => {
    const { data, pageId } = request
    return instance().put(`/api/order/${pageId}/update-order-tracking`, data)
  }
}

export default orderApi



// WEBPACK FOOTER //
// ./src/api/order.js